import { MOBILE_BREAKPOINT } from '@pique/core/components/app-sidebar/constants';

export type WorkbenchDocMode = 'edgeless' | 'page';
export type WorkbenchSplitOrientation = 'horizontal' | 'vertical';

export interface WorkbenchPlatform {
  readonly isMobile: boolean;
  readonly isTauri: boolean;
}

function getCurrentWorkbenchPlatform(): WorkbenchPlatform {
  const isNarrowViewport =
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;
  return {
    isMobile: environment.isBrowser
      ? environment.isMobile || isNarrowViewport
      : false,
    isTauri: environment.isTauri,
  };
}

export function canUseEdgelessSplit(
  platform: WorkbenchPlatform = getCurrentWorkbenchPlatform()
): boolean {
  return platform.isTauri || !platform.isMobile;
}

export function resolvePersistentWorkbenchDocMode<
  Mode extends WorkbenchDocMode | undefined,
>(mode: Mode, platform?: WorkbenchPlatform): Mode | WorkbenchDocMode {
  if (mode === 'edgeless' && !canUseEdgelessSplit(platform)) {
    return 'page';
  }
  return mode;
}

export function getWorkbenchSplitOrientation(
  viewportWidth: number
): WorkbenchSplitOrientation {
  return viewportWidth < MOBILE_BREAKPOINT ? 'vertical' : 'horizontal';
}
